$(document).ready(function() {

  // Image Unveil
  $("img").unveil();

  // Owl Slider Stuff
  var mainowl    = $(".main");
  mainowl.owlCarousel({
	responsive : {
		  	    // breakpoint from 0 up
		  	    0 : {
		  	    		items: 1,
		  	    		pagination: true
		  	    },
		  	    // breakpoint from 480 up 
		  	    480 : {
							items: 1
		  	    },
		  	    // breakpoint from 768 up
		  	    768 : {
							items: 1
		  	    }
		  	},
		  	nav: true,
    
  });

        
          
          if ($('html').hasClass('des')) {
            console.log('has classs')
            $('.zoomContainer').remove();
            $(".featured-image img").elevateZoom({
              zoomType : "inner",
              cursor: "crosshair",
              responsive: true
            });
          }
          else{
            console.log('does not have')
          }
          
          



});

jQuery(window).ready(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }
});